<template>
  <div class="user-info-tab" ref="tab">
    <vue-html2pdf
        :preview-modal="false"
        :manual-pagination="true"
        :pdf-content-width="`700px`"
        :pdf-quality="2"
        :html-to-pdf-options="htmlToPdfOptions"
        @hasDownloaded="hasDownloaded($event)"
        ref="html2Pdf"
    >
    </vue-html2pdf>

    <el-button
        type="danger"
        @click="downloadPdf()"
        :loading="generatingPdf"
    >Dispute
    </el-button>

    <el-form
        :model="formData"
        status-icon
        :rules="rulesForm"
        ref="userInfoTab"
        label-width="110px"
        class="demo-ruleForm"
        label-position="top"
    >
      <el-form-item label="First Name" prop="first_name" :error="errors.first_name">
        <el-input type="text" v-model="formData.first_name"></el-input>
      </el-form-item>
      <el-form-item label="Last Name" prop="last_name" :error="errors.last_name">
        <el-input type="text" v-model="formData.last_name"></el-input>
      </el-form-item>
      <el-form-item label="Email" prop="email" :error="errors.email">
        <el-input type="email" v-model="formData.email"></el-input>
      </el-form-item>
      <el-form-item label="Phone number" prop="phone" :error="errors.phone">
        <el-input type="phone" v-model="formData.phone"></el-input>
      </el-form-item>
      <el-form-item class="mb-0" label="Password" prop="password" :error="errors.password">
        <el-input  type="text" v-model="formData.password" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Confirmation Password" prop="password_confirmation" :error="errors.password_confirmation">
        <el-input type="text" v-model="formData.password_confirmation" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Gender" prop="gender" :error="errors.gender_id">
        <el-select v-model="formData.gender_id" placeholder="Select">
          <el-option
              v-for="item in formatData.gender"
              :key="item.id"
              :label="item.title"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Marital Status" prop="marital" :error="errors.material_status_id">
        <el-select v-model="formData.material_status_id" placeholder="Select">
          <el-option
              v-for="item in formatData.materialStatuses"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Age Range" prop="ageRange" :error="errors.age_range_id">
        <el-select v-model="formData.age_range_id" placeholder="Select">
          <el-option
              v-for="item in formatData.ageRange"
              :key="item.id"
              :label="item.range"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Address Line 1" prop="address" :error="errors.address">
        <el-input type="text" v-model="formData.address"></el-input>
      </el-form-item>
      <el-form-item label="Address Line 2" prop="address2" :error="errors.address2">
        <el-input type="text" v-model="formData.address2"></el-input>
      </el-form-item>
      <el-form-item label="Country" prop="country" :error="errors.country">
        <el-input type="text" v-model="formData.country"></el-input>
      </el-form-item>
      <el-form-item label="City" prop="city" :error="errors.city">
        <el-input type="text" v-model="formData.city"></el-input>
      </el-form-item>
      <el-form-item label="State" prop="state" :error="errors.state">
        <el-input type="text" v-model="formData.state"></el-input>
      </el-form-item>
      <el-form-item label="Zip" prop="zip" :error="errors.zip">
        <el-input type="text" v-model="formData.zip"></el-input>
      </el-form-item>
      <div v-if="$route.name === 'user-edit'">
        <div class="text-divider">Social network</div>
        <div class="flex center demo-box social-net">
          <div class="left-box">
            User connected with:
          </div>
          <div class="right-box box grow">
            <p class="accent_text">
              <a href="#" v-for="(itm, index) in userData.social_networks" :key="index">
                <i :class="selectIcon(itm)"></i>
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="text-divider">Footprints</div>
      <div class="flex center">
        <div class="right-box box grow">
          <el-tabs v-model="activeName" >
            <el-table :data="interests" style="width: 100%; ">
              <el-table-column
                  prop="utm_funnel"
                  label="Funnel"
                  column-key="funnel"

              > </el-table-column>

              <el-table-column prop="utm_source" label="Source"
                               column-key="source"

              ></el-table-column>

              <el-table-column prop="utm_campaign" label="Campaign"
                               column-key="campaign"

              ></el-table-column>

              <el-table-column prop="utm_medium" label="Medium"
                               column-key="medium"

              ></el-table-column>

              <el-table-column prop="utm_term" label="Term"
                               column-key="term"

              ></el-table-column>

              <el-table-column prop="utm_content" label="Content"  column-key="content"

              ></el-table-column>

              <el-table-column prop="referral" label="Referral"
                               column-key="referral"

              ></el-table-column>

              <el-table-column prop="gclid" label="GCLID"></el-table-column>



              <el-table-column prop="plan.name" label="Plan"  column-key="plan">
                <template slot-scope="scope">
                  {{ scope.row.plan.name}}
                </template>
              </el-table-column>

              <el-table-column prop="price" label="Price"
                               sort-key="price"
                               sortable
              ></el-table-column>

            </el-table>
          </el-tabs>
        </div>
      </div>

      <el-form-item>
        <el-button type="primary" @click="submitForm('userInfoTab')" v-if="$route.name === 'user-edit'">
          Save
        </el-button>

        <el-button type="primary" @click="nextStep" v-else>
          Next Step
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { mapGetters } from 'vuex'
import _ from "lodash"
import router from '../../../router/'
import VueHtml2pdf from "vue-html2pdf";
import PdfDisputeReport from "../PdfDisputeReport";
import html2canvas from 'html2canvas';
import moment from "moment-timezone";

export default {
  name: 'UserInfo',
  components: {
    VueHtml2pdf,
    PdfDisputeReport,
  },
  props: {
    imgArray: Array,
    isGeneratePDF: Boolean,
    isUserInfoScreenProcess: Boolean,
    userData: Object,
    formatData: Object,
    screenshotPage: HTMLDivElement
  },
  data () {
    return {
      activeName: 'Footprint',
      formErrors: {},
      formData: {
        id: null,
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        material_status_id: 1,
        age_range_id: 1,
        status_id: 1,
        gender_id: 1,
        created_at: '',
        address: '',
        address2: null,
        city: '',
        state: '',
        country: '',
        zip: '',
        mailchimp_exported: 0,
        notification: 1,
        feedback: 1,
        verified: 1,
        roles: [],
        password: '',
        password_confirmation: '',

        facebook: '',
        linkedin: '',
        instagram: '',
      },
      rulesForm: {
        first_name: [
          {
            required: true,
            message: 'Please input First name',
            trigger: 'blur',
          },
        ],
        email: [
          {required: true, message: 'Please input Email', trigger: 'blur'},
          {type: 'email', message: 'Email is not valid'},
        ],
      },
      htmlToPdfOptions: {
        margin: 0,
        filename: "DisputeReport.pdf",
        image: {
          type: 'jpeg',
          quality: 2
        },
        enableLinks: true,
        html2canvas: {
          scale: 1,
          useCORS: false
        },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        }
      },
      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
    }
  },
  computed: {
    ...mapGetters({
      interests: 'analytic/getInterests',
    }),
    formKeys() {
      return Object.keys(this.formData)
    },
    errors() {
      const copy = {}
      Object.keys(this.formErrors).forEach(key => {
        copy[key] = this.formErrors[key][0]
      })
      return copy
    }
  },
  watch: {
    userData: function (val, oldval) {
      let copy = {...this.formData, ...val}
      this.formData = copy
      if(this.formData) {
        this.$store.dispatch('analytic/getInterestReport', `user=${this.$route.params.id}&start=${this.formData.created_at}`);
      }
    },
    formData: {
      handler: function (val, oldVal) {
      },
      deep: true,
    },
    isUserInfoScreenProcess: function (val, oldVal) {
      if (val) {
        this.createCanvas()
      }
    },
    isGeneratePDF: function (val, old) {
      if (val) {
        this.generatingPdf = true;
        this.$store.dispatch('users/getDisputeReport', {'user_id': this.$route.params.id, 'imgArray': JSON.stringify(this.imgArray)})
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `Dispute Report.pdf`);
          document.body.appendChild(link);
          link.click();
          this.generatingPdf = false;
        })
        .catch((error) => {
          console.error('Error downloading dispute report:', error);
          this.generatingPdf = false;
        });

        this.$emit('disableGeneratePDF');
      }
    }
  },
  mounted () {
    let copy = {...this.formData, ...this.userData}
    this.formData = copy;
  },
  methods: {
    selectIcon (val) {
      if (val.network_name === 'Facebook') {
        return 'mdi mdi-facebook-box'
      } else if (val.network_name === 'Twitter') {
        return 'mdi mdi-twitter-box'
      } else if (val.network_name === 'Instagram') {
        return 'mdi mdi-instagram'
      } else if (val.network_name === 'Linkedin') {
        return 'mdi mdi-linkedin-box'
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate( async (valid) => {
        if (valid) {

          this.formData.roles = this.formData.roles.map(role => role.id);
          this.formErrors = {}
          const formData = _.pick(this.formData,[
            'first_name',
            'last_name',
            'email',
            'phone',
            'material_status_id',
            'age_range_id',
            'gender_id',
            'created_at',
            'address',
            'address2',
            'city',
            'state',
            'country',
            'zip',
            'mailchimp_exported',
            'notification',
            'feedback',
            'verified',
            'roles',
            'password',
            'password_confirmation',
            'facebook',
            'linkedin',
            'instagram',
          ])

          const {response} = await this.$store.dispatch('users/updateUser', {
            id: this.userData.id,
            data: formData
          })
          if (response && response.data && response.data.errors) {
            this.formErrors = {...response.data.errors}
          }

        } else {
          Message({
            message: 'Form not validated',
            type: 'error',
            duration: 5 * 1000
          })
          return false
        }
      })
    },
    nextStep(){
      // userInfoTab
      this.$refs.userInfoTab.validate(valid => {
        if (valid) {
          this.$emit('changeTab', 'userConfig', this.formData)
        } else {
          Message({
            message: 'Form not validated',
            type: 'error',
            duration: 5 * 1000
          })
          return false
        }
      })
    },
    downloadPdf() {
      this.$emit("takeScreenshots");
    },
    hasDownloaded (blobPdf) {
      this.pdfDownloaded = true;
      this.generatingPdf = false;
    },
    domRendered() {
      this.contentRendered = true;
    },
    async createCanvas() {
      this.screenshotPage.style.overflow = 'visible';
      this.screenshotPage.style.height = 'auto';
      const canvas = await html2canvas(this.screenshotPage, {
        scrollX: 0,
        scrollY: -window.scrollY,
        width: this.screenshotPage.offsetWidth,
        height: this.screenshotPage.scrollHeight,
      });
      const imgURL = {
        url: canvas.toDataURL('image/png'),
        name: 'User Info',
      };

      this.$emit('addNewImage', imgURL);
      this.$emit('toggleConfig');
      this.$emit('triggerNextTab', 'userConfig');
    }
  }

}
</script>

<style scoped lang="scss">
.mb-0 {
  margin-bottom: 10px !important;
}
.social-net{
  font-size: 24px;
  a{
    padding: 5px;
  }
}
</style>
